import { render } from "./BlockHighlight.vue?vue&type=template&id=4f7f5b66"
import script from "./BlockHighlight.vue?vue&type=script&lang=js"
export * from "./BlockHighlight.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__